import { AttributesActions } from "./AttributesActions";
import { IAttributes } from "../dto/IAttributes";
import React, { SetStateAction, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AttributesService } from "../../service";
import { ErrorToast, SuccessToast } from "../../../../shared/toasters/toasters";
import { t } from "i18next";

export const AttributesCreate = () => {
    const [currentAttribute, setCurrentAttribute] = useState<IAttributes>()
    const navigate = useNavigate();
    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();
        AttributesService.createAttribute(currentAttribute as IAttributes).then(response => {
            if (response?.id) {
                SuccessToast(`${t("toasts.successfully_created")} ${response?.title}`)
                navigate(-1);
            }
        }).catch(error => ErrorToast(error))
    }
    return (
        <AttributesActions currentAttribute={currentAttribute as IAttributes}
            setCurrentAttribute={setCurrentAttribute as React.Dispatch<SetStateAction<IAttributes>>}
            handleSubmit={handleSubmit} />
    )
}